var React = require('react');

function Sleigh (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M639.9 411.7c-2.2 39-36.9 68.3-75.9 68.3H48a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h519.3a24.61 24.61 0 0 0 15.4-43.8l-9.3-7.4a16 16 0 0 1-2.5-22.5l10-12.5a16 16 0 0 1 22.5-2.5l9.3 7.4a72.06 72.06 0 0 1 27.2 61z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 64a32 32 0 0 1 32-32h20.7A173.75 173.75 0 0 1 208 128a173.64 173.64 0 0 0 155.3 96H384a64.06 64.06 0 0 0 64-64V96h96a32 32 0 0 1 0 64v96a96 96 0 0 1-96 96v48h-64v-48H192v48h-64v-52.5C72.9 333.2 32 283.6 32 224V96A32 32 0 0 1 0 64z","className":"fa-primary","key":2})]);
}

Sleigh.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Sleigh;

Sleigh.default = Sleigh;
